import { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import breakpoints from 'helpers/breakpoints';

// Hook to measure window size on the client. Default is true.
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    if (window.innerWidth >= breakpoints.xsMax) {
      setIsMobile(false);
    }
    const throttled = throttle(() => {
      if (window.innerWidth >= breakpoints.xsMax) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }, 100);

    const resizeListener = window.addEventListener('resize', throttled);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return isMobile;
}
